'use client';

import { useEffect, useState } from 'react';
import { useTheme } from 'next-themes';
import { SunIcon, MoonIcon, MonitorIcon } from '@/components/ui/icons';

const THEMES = ['light', 'dark', 'system'];

/**
 * Theme selector with light/dark/system options.
 * Renders a placeholder until mounted to avoid hydration mismatch.
 */
export function ThemeToggle() {
  const [mounted, setMounted] = useState(false);
  const { theme, setTheme, resolvedTheme } = useTheme();

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return (
      <div
        className="h-9 w-9 rounded-md border border-border bg-surface-raised"
        aria-hidden="true"
      />
    );
  }

  const currentTheme = theme || 'system';
  const isDark = resolvedTheme === 'dark';

  return (
    <div className="flex items-center rounded-md border border-border bg-surface-raised p-0.5">
      <button
        type="button"
        onClick={() => setTheme('light')}
        aria-label="Light theme"
        aria-pressed={currentTheme === 'light'}
        className={`rounded-sm p-1.5 transition-colors ${
          currentTheme === 'light'
            ? 'bg-brand-100 text-brand-700 dark:bg-brand-900 dark:text-brand-200'
            : 'text-text-muted hover:text-text-primary'
        }`}
      >
        <SunIcon className="h-4 w-4" />
      </button>
      <button
        type="button"
        onClick={() => setTheme('dark')}
        aria-label="Dark theme"
        aria-pressed={currentTheme === 'dark'}
        className={`rounded-sm p-1.5 transition-colors ${
          currentTheme === 'dark'
            ? 'bg-brand-100 text-brand-700 dark:bg-brand-900 dark:text-brand-200'
            : 'text-text-muted hover:text-text-primary'
        }`}
      >
        <MoonIcon className="h-4 w-4" />
      </button>
      <button
        type="button"
        onClick={() => setTheme('system')}
        aria-label="System theme"
        aria-pressed={currentTheme === 'system'}
        className={`rounded-sm p-1.5 transition-colors ${
          currentTheme === 'system'
            ? 'bg-brand-100 text-brand-700 dark:bg-brand-900 dark:text-brand-200'
            : 'text-text-muted hover:text-text-primary'
        }`}
      >
        <MonitorIcon className="h-4 w-4" />
      </button>
    </div>
  );
}